import cloneDeep from 'lodash.clonedeep';
import uuidv4 from 'uuid/v4';

export function createDuplicateScenesElements(clonedElements, newActiveScribe) {
  let newSceneElementIds = [];

  for (const element of clonedElements) {
    element.id = uuidv4();
    newSceneElementIds.push(element.id);
    newActiveScribe.elements.push(element);
  }
  return newSceneElementIds;
}

export function updateNewSceneElements(newScene, newActiveScribe) {
  const elementsToBeCloned = newScene.elementIds.map(elId => newActiveScribe.elements.find(el => el.id === elId));

  const clonedElements = cloneDeep(elementsToBeCloned);

  const newSceneElementIds = createDuplicateScenesElements(clonedElements, newActiveScribe);

  newScene.elementIds = newSceneElementIds;

  return newScene;
}

export function createDuplicateScenes(scenesToCopy, newActiveScribe) {
  let clonedScenes = [];
  let clonedSelectedScenes = [];

  const lastScene = scenesToCopy[scenesToCopy.length - 1];

  for (const scene of scenesToCopy) {
    const newScene = cloneDeep(scene);
    newScene.id = uuidv4();
    newScene.active = scene === lastScene;

    const updatedScene = updateNewSceneElements(newScene, newActiveScribe);

    clonedScenes.push(updatedScene);
    clonedSelectedScenes.push(updatedScene.id);
  }

  return { clonedScenes, clonedSelectedScenes };
}

export function getScenesToCopy(newActiveScribe, sceneIds) {
  let selectedSceneIndexes = [];
  let scenesToCopy = [];

  for (const sceneId of sceneIds) {
    selectedSceneIndexes.push(newActiveScribe?.scenes.findIndex(scene => scene?.id === sceneId));
  }

  selectedSceneIndexes.sort((a, b) => a - b);

  for (const index of selectedSceneIndexes) {
    scenesToCopy.push(newActiveScribe?.scenes[index]);
  }

  return { selectedSceneIndexes, scenesToCopy };
}

export function duplicateScenesIntoScribe(scribe, sceneIds) {
  const newActiveScribe = cloneDeep(scribe);
  const activeScene = newActiveScribe.scenes.find(scene => scene.active);
  activeScene.active = false;
  const { selectedSceneIndexes, scenesToCopy } = getScenesToCopy(newActiveScribe, sceneIds);
  const insertSceneIndex = Math.max(...selectedSceneIndexes) + 1;
  const { clonedScenes, clonedSelectedScenes } = createDuplicateScenes(scenesToCopy, newActiveScribe);
  newActiveScribe.scenes.splice(insertSceneIndex, 0, ...clonedScenes);
  return { newActiveScribe, clonedSelectedScenes };
}
